package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.ActiveAnnouncement
import fr.manyverse.app.domain.model.EventContent
import fr.manyverse.app.domain.model.EventType
import fr.manyverse.app.domain.repository.GameEventRepository
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.filter
import kotlinx.coroutines.flow.map

/**
 * Use case for observing active announcements targeted at a specific user.
 * Filters events to only return announcements where the user is a target.
 */
class ObserveActiveAnnouncementsUseCase(
    private val gameEventRepository: GameEventRepository
) {
    /**
     * Observes new announcements for a specific user in a game table.
     * @param tableId The game table ID
     * @param currentUserId The user ID to filter announcements for
     * @return Flow emitting ActiveAnnouncement when the user is targeted
     */
    operator fun invoke(
        tableId: String,
        currentUserId: String
    ): Flow<ActiveAnnouncement> {
        return gameEventRepository.observeNewEvents(
            tableId = tableId
        ).filter { event ->
            event.eventType == EventType.ANNOUNCEMENT &&
                    event.targetParticipants.contains(currentUserId)
        }.map { event ->
            val announcement = event.content as EventContent.Announcement
            ActiveAnnouncement(
                eventId = event.id,
                text = announcement.text,
                imageUrl = announcement.imageUrl,
                targetParticipantIds = event.targetParticipants,
                createdAt = event.createdAt
            )
        }
    }
}
